<i18n>
{
"en": {
  "MANAGEROLES": "Manage Roles",
  "ADDNEWROLE": "Add New Role",
  "LOADING": "Loading...",
  "NAME": "Name",
  "ACTIONS": "Actions",
  "EDITROLE": "Edit Role",
  "NEWROLE": "New Role",
  "ROLENAME": "Role Name",
  "ROLENAME(ARABIC)": "Role Name (Arabic)",
  "SAVE": "Save",
  "CANCEL": "Cancel",
  "NAMESHOULDNOTBEEMPTY": "Name should not be empty!",
  "NAMEALREADYEXIST": "Name already exist!",
  "ABSENCE": "Absence",
  "BUS": "Bus",
  "CONFIGURATION": "Configuration",
  "DRIVER": "Driver",
  "GUARDIAN": "Guardian",
  "INCIDENT": "Incident",
  "LOG": "Log",
  "MESSAGE": "Message",
  "ROLE": "Role",
  "ROUTE": "Route",
  "STUDENT": "Student",
  "SUPERVISOR": "Supervisor",
  "USER": "User",
  "VIOLATION": "Violation",
  "VIEW": "View",
  "ADD/UPDATE": "Add/Update",
  "CHANGESTATUS": "Change Status",
  "DELETE": "Delete",
  "IMPORT": "Import",
  "SEND": "Send",
  "CLONE": "Copy",
  "SAVETAG": "Save Tag",
  "REGISTRATION": "Registration",
  "SUCCESS": "successfully saved!",
  "ROLEASSIGNED": "This role has been assigned to user(s)",
  "FLAG": "Flag",
  "ISNOTAVALIDARABICFORMAT": "is not a valid arabic format."
},
"ar": {
  "MANAGEROLES": "إدارة الأدوار",
  "ADDNEWROLE": "إضافة دور جديد",
  "LOADING": "جار التحميل...",
  "NAME": "الاسم",
  "ROLENAME": "اسم الدور",
  "ROLENAME(ARABIC)": "اسم الدور (عربي)",
  "ACTIONS": " اجراءات",
  "EDITROLE": "تحرير الدور",
  "NEWROLE": " دور جديد",
  "SAVE": " حفظ",
  "CANCEL": "الغاء",
  "NAMESHOULDNOTBEEMPTY": "لا يجب أن يكون الإسم فارغا!",
  "NAMEALREADYEXIST": "هذا الإسم موجود!",
  "ABSENCE": "غياب",
  "BUS": "حافلة",
  "CONFIGURATION": "ترتيب",
  "DRIVER": "سائق",
  "GUARDIAN": "ولي الامر",
  "INCIDENT": "حادث",
  "LOG": "سجل",
  "MESSAGE": "رسالة",
  "ROLE": "وظيفة",
  "ROUTE": "خط السير",
  "STUDENT": "طالب",
  "SUPERVISOR": "المشرفة",
  "USER": "المستعمل",
  "VIOLATION": "انتهاك",
  "VIEW": "شاهد",
  "ADD/UPDATE": "إضافة / تحديث",
  "CHANGESTATUS": "تغيير الحالة",
  "DELETE": "حذف",
  "IMPORT": "استيراد",
  "SEND": "إرسال",
  "CLONE": "استنساخ",
  "SAVETAG": "حفظ الشارة",
  "REGISTRATION": "التسجيل",
  "SUCCESS": "حفظ بنجاح!",
  "ROLEASSIGNED": "تم تعيين هذا الدور للمستخدم (المستخدمين)",
  "FLAG": "علم",
  "ISNOTAVALIDARABICFORMAT": ".ليست صيغة عربية صحيحة"
}
}
</i18n>
<template>
    <div id="role">
        <el-card class="card-border" ref="card" :body-style="{ padding: 0 }" v-loading="loading" :element-loading-text="$t('LOADING')">
            <div slot="header" class="clearfix">
                <span style="line-height: 36px;" class="title">{{$t('MANAGEROLES')}}</span>
                <el-button :disabled="!isAllowed('save')" icon="plus" @click="addRole({id: null, name: null, name_AR: null, status: '1', users: '0'})">{{$t('ADDNEWROLE')}}</el-button>
            </div>
            <el-row>
            <el-col :span="6">
              <VuePerfectScrollbar  ref="Scrollbar" >
                  <div class="scroll-border" :style="{ height: listHeight + 'px' }">
                  <el-button  class="list" :key="key" v-for="(role, key) in roles" @click="loadApplication(role)" v-bind:class="[role.id == selectedRole.id ? 'active' : '']">
                    <span v-text="RoleName(role)"></span><el-badge v-if="role.users > 0" :value="role.users" /><i v-if="isAllowed('delete')" @click="deleteRole(key, role)" class="fa fa-times"></i><i v-if="isAllowed('save')" @click="addRole(role)" class="fa fa-pencil"></i>
                  </el-button>
                  </div>
                </VuePerfectScrollbar>
            </el-col>
            <el-col :span="18">              
            <el-table
                :data="listApplications"
                :height="tableHeight"
                stripe
                style="width: 100%">
                <el-table-column
                    :label="$t('NAME')"
                    width="150"
                >
                  <template slot-scope="scope">
                    {{$t(scope.row.controller.toUpperCase())}}
                  </template>
                </el-table-column>
                <el-table-column
                    :label="$t('ACTIONS')"
                >
                    <template slot-scope="scope">
                        <el-checkbox-group v-model="listApplications[scope.$index]['access']" fill="#4b4b4b" border-color="#fff" text-color="#fff">
                          <el-checkbox-button :disabled="disableCheckBox(scope.$index, item)"  v-for="(item, key) in scope.row.methods" :label="item" :key="key" @change="saveRole(scope.$index)">{{$t(key)}}</el-checkbox-button>
                        </el-checkbox-group>                                             
                    </template>
                </el-table-column>
            </el-table>          
            </el-col>            
            </el-row>
        </el-card>
    </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  export default {
    components: {VuePerfectScrollbar},
    data () {
      return {
        loading: true,
        roles: [],
        selectedRole: {id: null},
        dupValue: null,
        filteredRoles: [],
        levels: [],
        tableHeight: 0,
        listHeight: 0,
        applications: {},
        access: {},
        showConfirm: true
      }
    },
    mounted () {
      this.switchLanguage()
      this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + 53)
      this.listHeight = this.tableHeight - 1
      this.getRoles()
    },
    computed: {
      listApplications () {
        let applications = this.applications[this.selectedRole.id]
        return applications
      }
    },
    methods: {
      getRoles () {
        let self = this
        this.$http.get('/role?exclude=1').then(function (response) {
          self.roles = response.data
          self.loading = false
          let role = (self.$route.params.id && self.getRoleByID(self.$route.params.id)) ? self.getRoleByID(self.$route.params.id) : self.roles[0]
          self.loadApplication(role)
        }).catch(function (response) {})
      },
      RoleName (row) {
        let name = row.name
        if (localStorage.getItem('lang') === 'ar' && row.name_AR) name = row.name_AR
        return name
      },
      nameValidation (rule, value, callback) {
        let arregex = /^[a-zA-Z\s-]*$/
        let message = this.$t('ISNOTAVALIDFORMAT')
        if (rule.field.split('_')[1] === 'AR') {
          message = this.$t('ISNOTAVALIDARABICFORMAT')
          arregex = /^[0-9\u0621-\u064A\u0660-\u0669\s-]*$/
        }
        if (value && !arregex.test(value)) callback(message)
        callback()
      },
      getRoleApplications (role) {
        let self = this
        this.loading = true
        this.$http.get('/role/' + role.id)
        .then(function (response) {
          self.$set(self.applications, role.id, response.data)
          self.loading = false
        })
        .catch(function (response) {})
      },
      saveRole (index = null) {
        return new Promise((resolve, reject) => {
          if (index !== null) this.checkIndex(index)
          let postData = {role: this.selectedRole, applications: this.applications[this.selectedRole.id]}
          let self = this
          this.$http.post('/role/save', postData).then(function (response) {
            let data = response.data
            if (self.selectedRole.id === null) {
              self.selectedRole.id = data.id
              self.loadApplication(self.selectedRole)
              self.roles.push(self.selectedRole)
            }
            self.message = data.message
            self.error = data.error
            resolve(data)
            if (!self.error) {
              self.$message({message: self.$t(self.message), type: 'success'})
              return
            }
          }).catch(function (err) {
            reject(err)
          })
        })
      },
      handleCurrentChange (val) {
        this.currentRow = val
      },
      loadApplication (role) {
        if (role.id !== null) this.selectedRole = role
        if (this.applications[role.id] === undefined) this.getRoleApplications(role)
      },
      addRole (data) {
        let self = this
        if (this.applications[data.id] === undefined) this.loadApplication(data)
        const h = this.$createElement
        let role = Object.assign({}, data)
        this.$msgbox({
          title: role.name ? this.$t('EDITROLE') : this.$t('NEWROLE'),
          message: h('el-form', {props: {labelWidth: '120px', labelPosition: 'top', model: role}, ref: 'popedForm'}, [
            h('el-form-item', {props: {label: this.$t('ROLENAME'), prop: 'name', rules: [{required: true, message: this.$t('NAMESHOULDNOTBEEMPTY'), trigger: 'blur'}, {validator: this.duplicateName, trigger: 'blur'}]}}, [
              h('el-input', {props: {value: role.name, autofocus: true}, on: {input: (val) => { role.name = val }}, ref: 'name'})
            ]),
            h('el-form-item', {props: {label: this.$t('ROLENAME(ARABIC)'), prop: 'name_AR', rules: [{validator: this.nameValidation, trigger: 'blur'}, {validator: this.duplicateName, trigger: 'blur'}]}}, [
              h('el-input', {props: {value: role.name_AR}, on: {input: (val) => { role.name_AR = val }}, ref: 'name_AR'})
            ])
          ]),
          showCancelButton: true,
          confirmButtonText: this.$t('SAVE'),
          cancelButtonText: this.$t('CANCEL'),
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              this.$refs['popedForm'].validate((valid) => {
                this.dupValue = null
                if (valid) {
                  for (let key in this.roles) {
                    if (this.roles[key].id !== role.id && this.roles[key].name.toLowerCase() === role.name.toLowerCase()) {
                      this.dupValue = role.name.toLowerCase()
                      this.$refs['popedForm'].validate()
                    } else if (this.roles[key].id !== role.id && this.roles[key].name_AR && role.name_AR && this.roles[key].name_AR.toLowerCase() === role.name_AR.toLowerCase()) {
                      this.dupValue = role.name_AR.toLowerCase()
                      this.$refs['popedForm'].validate()
                    }
                  }
                  if (this.dupValue === null) done(this.resetForm(role.id))
                }
              })
            } else {
              done(this.resetForm(role.id, true))
            }
          }
        }).then(data => {
          if (role.id == null) self.selectedRole = Object.assign({}, role)
          self.saveRole().then(() => {
            self.selectedRole.name = role.name
            self.selectedRole.name_AR = role.name_AR
          })
        }).catch(() => {
        })
      },
      resetForm (id, reset = false) {
        if (this.$refs['popedForm'] === undefined) return
        if (reset) this.$refs['popedForm'].resetFields()
        this.$refs.name.setCurrentValue(id === null ? null : this.selectedRole.name)
        this.$refs.name_AR.setCurrentValue(id === null ? null : this.selectedRole.name_AR)
      },
      duplicateName (rule, value, callback) {
        if (value && this.dupValue === value.toLowerCase()) callback(this.$t('NAMEALREADYEXIST'))
        callback()
      },
      disableCheckBox (index, method) {
        if (!this.isAllowed('save')) return true
        let id = this.selectedRole.id
        if (this.applications[id][index].access.indexOf('index') < 0 && method !== 'index' && Object.values(this.applications[id][index].methods).indexOf('index') >= 0) return true
        return false
      },
      checkIndex (index) {
        let id = this.selectedRole.id
        if (this.applications[id][index].access.indexOf('index') < 0 && Object.values(this.applications[id][index].methods).indexOf('index') >= 0) this.applications[id][index].access = []
      },
      getRoleByID (id) {
        for (let role in this.roles) {
          if (this.roles[role].id === id) return this.roles[role]
        }
        return false
      },
      deleteRole (key, role) {
        let self = this
        if (parseInt(role.users) !== 0) {
          return self.$message({
            message: self.$t('ROLEASSIGNED'),
            type: 'warning',
            showClose: true
          })
        }
        let postData = {Level: role.id, Status: 0}
        this.$http.post('/role/delete', postData)
          .then(function (response) {
            if (response.data.error) {
              return self.$message({
                message: self.$t(response.data.message),
                type: 'warning',
                showClose: true
              })
            }
            self.$delete(self.roles, key)
            if (self.roles[key - 1] !== undefined) self.loadApplication(self.roles[key - 1])
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
  }
</script>

<style>
  #role .el-message-box__headerbtn {display:none}
  #role .fa.fa-pencil, #role .fa.fa-times{visibility: hidden;float:right;margin-top: 10px;padding-right: 15px;padding-left: 0px;}  
  #rtl #role .fa.fa-pencil, #rtl #role .fa.fa-times{visibility: hidden;float:left;margin-top: 10px;padding-left: 15px;padding-right: 0px}  
  #role button.list.active:hover .fa.fa-pencil, #role button.list.active:hover .fa.fa-times, #rtl  #role button.list.active:hover .fa.fa-pencil, #rtl #role button.list.active:hover .fa.fa-times{visibility:visible;}
</style>



// WEBPACK FOOTER //
// Role.vue?eac6e076